var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { space, layout, typography, compose, system, } from 'styled-system';
import { get } from '../tools/utils';
var StyledLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  ",
    "\n"])), get.colors('slate-5'), compose(space, layout, typography), system({
    textTransform: true,
    whiteSpace: true,
}));
var Label = React.forwardRef(function (_a, ref) {
    var htmlFor = _a.htmlFor, _b = _a.fontSize, fontSize = _b === void 0 ? 1 : _b, _c = _a.textTransform, textTransform = _c === void 0 ? 'none' : _c, _d = _a.whiteSpace, whiteSpace = _d === void 0 ? 'normal' : _d, children = _a.children, rest = __rest(_a, ["htmlFor", "fontSize", "textTransform", "whiteSpace", "children"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledLabel, __assign({ htmlFor: htmlFor, fontSize: fontSize, textTransform: textTransform, whiteSpace: whiteSpace, fontWeight: "bold", ref: ref }, rest), children)));
});
export { Label };
var templateObject_1;
//# sourceMappingURL=Label.js.map